import { FullWidthImageContentBlock } from "~/types/asgard/PostContentBlock";

export const apiToFullWidthImageBlockProps = ({
  fullwidth_image: media,
  fullwidth_url: linkHref,
}: FullWidthImageContentBlock) => ({
  alt: media.alt_text,
  captionText: media.caption,
  width: media.width,
  height: media.height,
  src: media.sizes.full.source_url,
  linkHref: linkHref || null,
});
